import { createSlice } from "@reduxjs/toolkit";

const reducerSlice = createSlice({
  name: "products",
  initialState: {
    page: "all",
    id: "",
    typeForm: "",
    bulkAddDialog: false,
    incompletedProducts: [],
    selectedIncompletedProduct: null,
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setId: (state, action) => {
      state.id = action.payload;
    },
    setTypeForm: (state, action) => {
      state.typeForm = action.payload;
    },
    setBulkAddDialog: (state, action) => {
      state.bulkAddDialog = action.payload;
    },
    setIncompletedProducts: (state, action) => {
      state.incompletedProducts = action.payload;
    },
    setSelectedIncompletedProduct: (state, action) => {
      state.selectedIncompletedProduct = action.payload;
    },
  },
});

export const { setPage, setId, setTypeForm, setBulkAddDialog, setIncompletedProducts, setSelectedIncompletedProduct } = reducerSlice.actions;
export default reducerSlice;
